
# 讨论相关
$ ->
  $(document).on 'click', '.form-editor .cb-visitor-lock', (e) ->
    $cb = $(@)
    $form = $cb.closest('.form-editor')
    if $cb.prop('checked')
      $form.find('.member-list .visitor').prop('checked', false).closest('li').hide()
    else
      $form.find('.member-list .visitor').closest('li').show()

  .on 'ajax:success', ".message-actions .stick", stickTopic
  .on 'ajax:success', ".message-actions .unstick", unstickTopic
  .on 'ajax:success', ".message-actions .archive, .message-actions .unarchive", archiveTopic
  .on 'ajax:success', ".messages .archive-info .reopen", reopenTopic


stickTopic = (e, result) ->
  $messages = $('.messages')
  if result.success
    $message = $(@).closest('.message')
    $message.prependTo $messages
      .addClass('sticky')
    tower.highlight $message


unstickTopic = (e, result) ->
  if result.success
    $messages = $('.messages')
    $message = $(@).closest('.message')
    $message.prependTo $messages
      .removeClass('sticky')
    sortTopics()
    tower.highlight $message


archiveTopic = (e, result) ->
  if result.success
    $btn = $(@)
    $messages = $('.messages')
    $message = $btn.closest('.message')
    tips = if $btn.hasClass('archive') then '你刚刚结束了讨论' else '你重新打开了讨论'
    $info = $("""
      <p class="archive-info" style="display:none;">
        #{tips}：
        <a href="#{$message.find('.message-link').attr('href')}" class="content" data-stack>
          #{$message.find('.message-title').text()}
        </a>

        <a href="#{$message.find('.unarchive').attr('href')}"" class="reopen" title="重新打开讨论"
            data-method="post" data-remote="true" data-loading="true">
            重新打开
        </a>
      </p>
    """)

    $messages.find('.archive-info').remove()
    $info.insertBefore($message).slideDown('fast')
    $message.slideUp('fast')


reopenTopic = (e, result) ->
  if result.success
    $info = $(@).closest('.archive-info')
    $message = $info.next('.message')
    $info.slideUp('fast')
    $message.slideDown 'fast', ->
      tower.highlight $message


sortTopics = ->
  $messages = $('.messages')
  messageEls = $messages.find('.message:not(.sticky)')
  format = "YYYY-MM-DD HH:mm:ss Z"
  messageEls.sort (a, b) ->
    d1 = moment.tz($(a).data('last-comment-at'), format, tower.me.tz)
    d2 = moment.tz($(b).data('last-comment-at'), format, tower.me.tz)
    d2.diff d1

  $messages.prepend messageEls
  $messages.find('.sticky').prependTo $messages


$.extend tower,
  # 初始化评论和讨论的通知人列表，为了缓存方便，包含自己，所以需要去掉
  # 在评论成功之后也会被执行用于更新缩略的通知人列表
  adjustCCList: ->
    $page = $('.workspace .page-inner:last')
    jFrm = $page.find('.comment-form, .form-new-discussion')
    receiver = jFrm.find('.receiver')
    members = jFrm.find('.member-list')
    members.find("input[value='#{ tower.me.guid }']:checkbox").closest('li').remove()
    members.find('input.visitor:checkbox').closest('li').remove()  if $page.is('[data-visitor-locked]')
    tower.adjustSubGroupsTag members
    return  unless receiver.length
    receiver.empty()
    selectedMembers = members.find('input:checked')
    selectedMembersCount = selectedMembers.length
    if selectedMembers.length
      html = ''
      selectedMembers.slice(0, 3).each (i, m) ->
        member = $(this)
        guid = member.val()
        name = member.parent().text()
        html += '<span class="sp">, </span>'  if i > 0
        html += "<span data-guid='#{ guid }'>#{ name }</span>"

      html += "等#{ selectedMembersCount }人"  if selectedMembersCount > 3
      receiver.html html
    else
      receiver.closest('.notify-title-select').hide()
        .next('.notify-title-select').show()
        .closest('.notify-title')
        .next('.form-field').show()

  adjustSubGroupsTag: ($el) ->
    $('.notify .group-select').each ->
      $group = $(@)
      group = $group.data 'subgroup'
      $group.remove() if (group isnt -1) and $el.find("input[data-subgroup*='#{group}']").length is 0
